<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'app',
		components: {

		}
	}
</script>

<style>
	* {
		box-sizing: border-box;
	}

	html {
		scroll-behavior: smooth;
		-webkit-text-size-adjust: 100%;
		-ms-text-size-adjust: 100%;
	}

	body {
		margin: 0;
		padding: 0;
		overflow-x: hidden;
	}

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
		min-width: 320px;
	}

	img {
		max-width: 100%;
		height: auto;
		display: block;
	}

	/* 移动端触摸优化 */
	@media (max-width: 768px) {
		* {
			-webkit-tap-highlight-color: transparent;
		}

		button,
		a {
			-webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
		}
	}
</style>